module.exports = __webpack_public_path__ + "static/media/caseDetailActivity.67aef839.jpg";